"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MuiListItemText = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));

var _Storyblok = _interopRequireDefault(require("../../../../../../utils/Storyblok"));

/**
 * MuiListItemText is used in storyblok redirect to react routes
 */
var MuiListItemText = function MuiListItemText(_ref) {
  var secondary = _ref.secondary,
      primary = _ref.primary,
      rootClass = _ref.rootClass;

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass);

  return /*#__PURE__*/_react.default.createElement(_ListItemText.default, {
    className: styles.root,
    primary: primary,
    secondary: secondary
  });
};

exports.MuiListItemText = MuiListItemText;
var _default = MuiListItemText;
exports.default = _default;
MuiListItemText.propTypes = {
  /** primary text */
  primary: _propTypes.default.string.isRequired,

  /** secondary text */
  secondary: _propTypes.default.string,

  /**
   * stroyblok multiselect of css classes
   * Override or extend the styles applied to the component
   * */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string)
};
MuiListItemText.defaultProps = {
  rootClass: [],
  secondary: ''
};